const componentStrings = {
  datepicker: {
    sk: {
      today: 'Dnes',
      yesterday: 'Včera',
      last7days: 'Posledných 7 dní',
      last30days: 'Posledných 30 dní',
      thisMonth: 'Tento mesiac',
      lastMonth: 'Minulý mesiac',
      customRange: 'Vlastný interval',
      apply: 'Potvrdiť',
      cancel: 'Zrušiť',
      showAll: 'Zobraziť všetko',
      statistics: 'Štatistiky'
    },
    cz: {
      today: 'Dnes',
      yesterday: 'Včera',
      last7days: 'Posledních 7 dní',
      last30days: 'Posledních 30 dní',
      thisMonth: 'Tento měsíc',
      lastMonth: 'Minulý měsíc',
      customRange: 'Vlastní interval',
      apply: 'Potvrdit',
      cancel: 'Zrušit',
      showAll: 'Zobrazit všechno',
      statistics: 'Statistiky'
    },
    en: {
      today: 'Today',
      yesterday: 'Yesterday',
      last7days: 'Last 7 days',
      last30days: 'Last 30 days',
      thisMonth: 'This month',
      lastMonth: 'Last month',
      customRange: 'Custom range',
      apply: 'Apply',
      cancel: 'Cancel',
      showAll: 'Show all',
      statistics: 'Statistics'
    },
    de: {
      today: 'Heute',
      yesterday: 'Gestern',
      last7days: 'Letzten 7 Tage',
      last30days: 'Letzte 30 Tage',
      thisMonth: 'Diesen Monat',
      lastMonth: 'Im vergangenen Monat',
      customRange: 'Benutzerdefinierten Bereich',
      apply: 'Sich bewerben',
      cancel: 'Stornieren',
      showAll: 'Zeige alles',
      statistics: 'Statistiken'
    }
  },
  sensorChart: {
    sk: {
      temperature: 'Teplota [°C]',
      moisture: 'Vlhkosť [%]',
      pressure: 'Tlak [hPa]',
      precipitation: 'Úhrn zrážok [mm/m2]',
      irradiation: 'Intenzita slnečného žiarenia [W/m2]',
      time: 'Čas',
      battery: 'Batéria'
    },
    cz: {
      temperature: 'Teplota [°C]',
      moisture: 'Vlhkost [%]',
      pressure: 'Tlak [hPa]',
      precipitation: 'Úhrn zrážek [mm/m2]',
      irradiation: 'Intenzita slunečnýho záření [W/m2]',
      time: 'Čas',
      battery: 'Baterie'
    },
    en: {
      temperature: 'Temperature [°C]',
      moisture: 'Moisture [%]',
      pressure: 'Pressure [hPa]',
      precipitation: 'Precipitation [mm/m2]',
      irradiation: 'Solar irradiation [W/m2]',
      time: 'Time',
      battery: 'Battery'
    },
    de: {
      temperature: 'Temperatur [°C]',
      moisture: 'Feuchtigkeit [%]',
      pressure: 'Druck [hPa]',
      precipitation: 'Niederschlag [mm/m2]',
      irradiation: 'Sonneneinstrahlung [W/m2]',
      time: 'Zeit',
      battery: 'Batterie'
    }
  },
  widgetChart: {
    sk: {
      mildew: 'Infekčný tlak - Peronospora',
      hazard1: 'Kalamitný výskyt',
      hazard2: 'Sporadicko-kalamitný výskyt',
      realPrec: 'Kumulatívna hodnota skutočných zrážok'
    },
    cz: {
      mildew: 'Infekční tlak - Peronospora',
      hazard1: 'Kalamitní výskyt',
      hazard2: 'Sporadicko-kalamitní výskyt',
      realPrec: 'Kumulativní hodnota skutečních srážek'
    },
    en: {
      mildew: 'Infectious pressure - Mildew',
      hazard1: 'Calamity occurence',
      hazard2: 'Sporadic-calamitous occurence',
      realPrec: 'Cummulativ value of real precipitation'
    },
    de: {
      mildew: 'Infektiöser Druck - Schimmel',
      hazard1: 'Unglücksfall',
      hazard2: 'Sporadisch-katastrophales Auftreten',
      realPrec: 'Kummulativwert des realen Niederschlags'
    }
  },
  export: {
    sk: {
      avgTemp: 'Priem. teplota[°C]',
      sumPrec: 'Suma zrážok[mm/m2]',
      date: 'Dátum'
    },
    cz: {
      avgTemp: 'Prum. teplota[°C]',
      sumPrec: 'Suma srážek[mm/m2]',
      date: 'Datum'
    },
    en: {
      avgTemp: 'Avg. temp[°C]',
      sumPrec: 'Sum. precip[mm/m2]',
      date: 'Date'
    },
    de: {
      avgTemp: 'Durchschnittstemperatur[°C]',
      sumPrec: 'Summe der Niederschlage[mm/m2]',
      date: 'Datum'
    }
  }
}

export { componentStrings }



//////////////////
// WEBPACK FOOTER
// ./static/localization/componentStrings.js
// module id = 229
// module chunks = 1